import { replacePathParams } from '@/api/utils';

export const hubsApiPaths = {
  list: '/facilityservice/hubs',
  hubById: '/facilityservice/hubs/:hubId',
} as const;

export const getHubApiUrl = {
  list: () => hubsApiPaths.list,
  hubById: (hubId: string) => replacePathParams(hubsApiPaths.hubById, { hubId }),
};
